export let state = {
  isAuthenticated: false,
  user: {},
  role: {},
  permission: [],
};
